import { render } from "./MediaBlock.vue?vue&type=template&id=21adeee8&scoped=true&ts=true"
import script from "./MediaBlock.vue?vue&type=script&lang=ts"
export * from "./MediaBlock.vue?vue&type=script&lang=ts"

import "./MediaBlock.vue?vue&type=style&index=0&id=21adeee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21adeee8"]])

export default __exports__